import { createApiResource, UnpagedListHookResult, UnpagedListResource } from '../apiResourceFactory';
import { ServiceTitanAPI } from '../apiService';
import { ServiceTitanJobType, ServiceTitanJobTypeQueryParams } from '../apiTypes.shim';

type ServiceTitanJobTypeResource = UnpagedListResource<ServiceTitanJobType, ServiceTitanJobTypeQueryParams> & {
  useUnpagedListCached: () => UnpagedListHookResult<ServiceTitanJobType>;
};

export const createServiceTitanJobTypeResource = (companyId: string): ServiceTitanJobTypeResource => {
  const jobTypeUri = `${companyId}/job-types`;
  const { useUnpagedList, unpagedList, unpagedListQueryKey } = createApiResource(ServiceTitanAPI, jobTypeUri);

  return {
    useUnpagedList,
    unpagedList,
    unpagedListQueryKey,
    useUnpagedListCached: () => useUnpagedList({}, { refetchOnMount: false })
  };
};
